// extracted by mini-css-extract-plugin
export default {"root":"PrimarySlice_root__l2VNL","mobile":"PrimarySlice_mobile__Yl0Xl"};